module.exports = "<div class=\"login-info\" style=\"height:55px\">\n  <span *ngIf=\"user?.picture\" style=\"padding-top:7px;padding-bottom:9px\">\n\t  <img [src]=\"user.picture\" alt=\"me\" class=\"online\" style=\"width:35px\"/>\n    <label style=\"font-size:14px;width:108px;vertical-align: middle\">{{ user.username }}</label>\n     <!-- logout button -->\n    <span><sa-logout></sa-logout></span>\n     <!-- end logout button -->\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/user/login-info/login-info.component.html
// module id = ./src/app/shared/user/login-info/login-info.component.html
// module chunks = main